import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { ambienteAplicacion, urlProcesoCotizadorParametrico } from '../../constants/urls';
import Formulario from '../Generales/Formulario';

const ComponentFormularioParametrico = ({
    codigoFormulario,
    urlSiguiente,
    history,
    loading,
    paso,
    setLoading,
    guardarInformacion,
    values,
    setValues,
    setValuesInicial,
    valuesConTitulo,
    setValuesConTitulo,
    onSubmit,
    bloqueoListaNegra,
    mensajeListaNegra
}) => {






    return (
        <Formulario
            mensajeListaNegra={mensajeListaNegra}
            bloqueoListaNegra={bloqueoListaNegra}
            codigoFormulario={codigoFormulario}
            anchoPagina={8}
            setLoading={(value) => setLoading(value)}
            onSubmit={async (values, tieneErrores, errores, valuesConTitulo) => {

                onSubmit(values, tieneErrores, errores, valuesConTitulo)





            }}
            values={values}
            valuesConTitulo={valuesConTitulo}
            setValuesConTitulo={() => { setValuesConTitulo() }}
            onChange={(key, values) => {
                setValues(key, values)
            }}
            onChangeTitulos={(key, values) => {
                setValuesConTitulo(values)
            }}
            setValuesInicial={(values) => {
                setValuesInicial(values)
            }}
        />
    )

}

export default ComponentFormularioParametrico